export default __webpack_public_path__ + "static/media/gallery2.adaf8ab9.JPG";